module.exports = __webpack_public_path__ + "static/img/9areaB_03.f8646e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_03.png
// module id = 1235
// module chunks = 1